import { connect } from 'react-redux';
import Trending from './Trending';

const mapStateToProps = ({ content: { trending }}) => ({
  tiles: trending
});

export default connect(mapStateToProps)(Trending);




// WEBPACK FOOTER //
// ./src/universal/components/Trending/index.js